import { render, staticRenderFns } from "./class.vue?vue&type=template&id=90742f94"
import script from "./class.vue?vue&type=script&lang=js"
export * from "./class.vue?vue&type=script&lang=js"
import style0 from "./class.vue?vue&type=style&index=0&id=90742f94&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports